import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <div className="on-dark violet-canvas flex-1 w-full min-h-[70vh] flex flex-col items-center justify-center text-center px-5">
      <SEO title="Seite nicht gefunden" />
      <div className="font-serif text-8xl font-light text-[#632A8E]">404</div>
      <h1 className="font-serif text-3xl mt-4">Diese Seite existiert nicht</h1>
      <p className="text-[#B79FD1] mt-3">Vielleicht finden Sie in der Galerie, wonach Sie suchen.</p>
      <Link to="/" className="mt-8 inline-flex items-center border border-[#F4C542] text-[#F4C542] px-8 py-3 text-sm hover:bg-[#F4C542] hover:text-[#32104F] transition-colors rounded-md">
        Zur Startseite
      </Link>
    </div>
  );
}
